import classNames from 'classnames';
import React, { useContext, useId } from 'react'
import { useTranslation } from 'react-i18next';
import { getNotifier } from '../../../services/notifier';
import UploadAvatarButton from './UploadAvatarButton/UploadAvatarButton';
import { ApiContext } from '../../../services/api/api-config';
import FilePreview from '../../FilePreview/FilePreview';
import './FileUploader.scss';

const FileUploader = ({ value, onChange, btnLabel, maxFileSizeInMB=null, fileTypes=[] }) => {
    const id = useId(); 
    const {t} = useTranslation();
    const api = useContext(ApiContext);
    const bytesToMegaBytes = bytes => bytes / (1024 ** 2);
    
    const handleChange = e => {
        if (e.target.files.length) {
            if(maxFileSizeInMB){
                const sizeInMB = bytesToMegaBytes(e.target?.files[0]?.size);
                if(maxFileSizeInMB<sizeInMB)
                    return getNotifier().error(`${t('MaxFileSizeExceed')} ${maxFileSizeInMB}MB`);
            }

            onChange(e.target?.files[0]);
        }
    };

    // if is image and is not undefined
    const isImage = value && (value?.type?.startsWith('image/') || value?.mimeType?.startsWith('image/'));

    const getStyles = () => {
        if(!isImage)
            return {};

        let imageStyles = {
            backgroundImage: '',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            borderRadius: '8px',
        };
        
        if(value?.id) {
            imageStyles.backgroundImage = `url(${api.appFiles.getUrl(value)})`;

        } else if(value?.name && !value?.id) {
            imageStyles.backgroundImage = `url(${URL.createObjectURL(value)})`;
        }

        return imageStyles;
    }

    return (
        <>
        <div className={classNames('FileUploader')}>
            <div className='FileUploader__control'>
                {(!value || isImage) ?
                    <label htmlFor={id} role='button' style={getStyles()}>
                        <UploadAvatarButton btnLabel={btnLabel} />
                    </label> 
                        :
                    <FilePreview file={value} onDelete={() => onChange(null)} />}
                
                <input
                    id={id}
                    key={value?.id}
                    type="file"
                    style={{ display: "none" }}
                    onChange={handleChange}
                    multiple={false}
                    accept={fileTypes.map(f => `.${f.toLowerCase()}`).join(', ')}
                />
            </div>
        </div>
        {fileTypes &&
            <div className="file-label">
                {maxFileSizeInMB && <div>{t('Max-size')}: {maxFileSizeInMB}MB</div>}                        
                <div>Types: <span>{fileTypes.map(f => `.${f.toLowerCase()}`).join(', ')}</span></div>
            </div>}
        </>
    );
}

export default FileUploader;